import {
  AddContainer,
  AddInfo,
  AddContacts,
  ShortAddContainer,
  ShortAddWrapper,
} from "./short-add.styles"
import Button from "../button/button.component"
import { Link } from "react-scroll"

import "./styles.scss"

const ShortAdd = ({ props }) => {
  return (
    <ShortAddWrapper className="short-ads">
      <ShortAddContainer>
        <AddContainer>
          <AddInfo>
            <h2>{props[1]}</h2>
            <span>{props[2]}</span>
          </AddInfo>
          <AddContacts>
            <Link
              to="contacts"
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              <Button children={props[3]} />
            </Link>
          </AddContacts>
        </AddContainer>
      </ShortAddContainer>
    </ShortAddWrapper>
  )
}

export default ShortAdd
